// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none{display:none}.sf-overlay{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1;z-index:var(--overlay-z-index,1);background:rgba(var(--c-gray-base),.7);background:var(--overlay-background,rgba(var(--c-gray-base),.7))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
